
@if (extraFields()?.[translate.currentLang] && extraFields()?.[translate.currentLang].length !== 0){

    <section class="details-page__extra-info">
        <h3 
          class="ci-heading-h3-s-bold extra-info__title"
        >
          {{ 'Información Adicional' | translate }}
        </h3>
        
        <ul class="extra-info__list">
            @for (item of extraFields()[translate.currentLang]; track item){
                <li class="extra-info__list__item">
                    <b class="ci-paragraph-p3-semibold">
                      {{ item.button_text }}: 
                    </b>
                    <span 
                      class="ci-paragraph-p3-regular"
                    >
                      {{ item.content_text }}
                  </span>            
                </li>
            }
        </ul>
    </section>
    
}